import React, { useState } from 'react';

const PriceGuide = () => {
  const [darkMode, setDarkMode] = useState(false);

  const toggle = () => setDarkMode(!darkMode);
  const styles = getStyles(darkMode);

  const plans = [
    {
      title: 'One-Page Author Website',
      price: '£399',
      features: [
        'Home, About, Contact',
        'Social Media Integration',
        'Responsive Design',
        '1 revision',
        'Delivery: 1 week (post content submission)'
      ],
    },
    {
      title: 'Multi-Section Landing Page',
      price: '£1000 - £2000',
      features: [
        'Rich Storytelling Layout',
        'Embedded Media',
        'Newsletter Signup or Product CTA',
        '1-2 revisions',
        'Delivery: 1 week (post content submission)'
      ],
    },
    {
      title: 'Full Author Website',
      price: '£1850',
      features: [
        '5-7 Pages (e.g., Home, Books, Blog, About, Events)',
        'Blog Integration',
        'Newsletter and Contact Forms',
        '3 revisions',
        'Delivery: 2-3 weeks (post content submission)'
      ],
    },
    {
      title: 'Chat Bots & Dashboards',
      price: '£299 - £12000 (Monthly fee £399)',
      features: [
        'LLM Training (e.g., content training, Presonal avatar)',
        'Calender Integration',
        'Contact Forms',
        '2-6 revisions',
        'Delivery: 2 weeks (post content submission)'
      ],
    },
  ];

  return (
    <div style={styles.container}>
      <div style={styles.toggleWrap}>
        <button onClick={toggle} style={styles.toggle}>
          {darkMode ? '☀️ Light Mode' : '🌙 Dark Mode'}
        </button>
      </div>

      <h1 style={styles.heading}>📚 Website Design Price Guide</h1>

      <div style={styles.cardContainer}>
        {plans.map((plan, index) => (
          <div key={index} style={styles.card}>
            <h2 style={styles.cardTitle}>{plan.title}</h2>
            <p style={styles.price}>{plan.price}</p>
            <ul style={styles.featureList}>
              {plan.features.map((feature, i) => (
                <li key={i} style={styles.featureItem}>✅ {feature}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      <p style={styles.note}>
        Note: Timelines depend on full submission of your content.
      </p>
    </div>
  );
};

const getStyles = (darkMode) => ({
  container: {
    fontFamily: 'Arial, sans-serif',
    maxWidth: '1100px',
    margin: '80px auto',
    padding: '40px',
    backgroundColor: darkMode ? '#0e0e0e' : '#fff',
    color: darkMode ? '#f5f5f5' : '#222',
    borderRadius: '12px',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
    transition: 'all 0.3s ease-in-out',
  },
  toggleWrap: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: '20px',
  },
  toggle: {
    padding: '8px 14px',
    fontSize: '14px',
    borderRadius: '6px',
    backgroundColor: darkMode ? '#333' : '#e0e0e0',
    color: darkMode ? '#fff' : '#111',
    border: 'none',
    cursor: 'pointer',
  },
  heading: {
    fontSize: '36px',
    fontWeight: '700',
    marginBottom: '40px',
    textAlign: 'center',
    color: darkMode ? '#f5f5f5' : '#111',
  },
  
  cardContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
    gap: '30px',
  },
  card: {
    backgroundColor: darkMode ? '#1c1c1c' : '#fafafa',
    padding: '24px',
    borderRadius: '12px',
    boxShadow: darkMode
      ? '0 4px 10px rgba(255,255,255,0.05)'
      : '0 4px 12px rgba(0,0,0,0.1)',
    transition: 'transform 0.2s ease-in-out',
  },
  cardTitle: {
    fontSize: '22px',
    fontWeight: '600',
    marginBottom: '12px',
    color: darkMode ? '#f5f5f5' : '#111',
  },
  price: {
    fontSize: '20px',
    fontWeight: '700',
    marginBottom: '16px',
  },
  featureList: {
    listStyle: 'none',
    padding: 0,
    lineHeight: 1.8,
  },
  featureItem: {
    fontSize: '15px',
  },
  note: {
    fontSize: '14px',
    fontStyle: 'italic',
    color: darkMode ? '#aaa' : '#666',
    textAlign: 'center',
    marginTop: '40px',
  },
});

export default PriceGuide;
